<template>
   <router-view/>
   <loading/>
   <alert/>
   <confirm/>
</template>
<script>
import Loading from 'Common/Loading'
import Alert from 'Common/notification/AlertView'
import Confirm from 'Common/notification/Confirm'

export default {
  components: { Loading, Alert, Confirm }
}
</script>
<style lang="less">
  #app {
    margin: 0 auto;
    width: 100%;
  }
</style>
